import * as React from 'react'; // https://github.com/aelbore/esbuild-jest/issues/61
import Serializer, {
  type DeserializeArguments,
  type SerializeArguments,
} from './Serializer';
import { type TableRowElement } from '../../types/aha-editor';
import { isTableRowElement } from '../../types/guards';
import { isHTMLElementNode } from '../helpers/serializerHelpers';

class SerializerTableRow extends Serializer {
  static serialize({ node, children }: SerializeArguments) {
    if (!isTableRowElement(node)) return;

    return <tr className="Editor__tr">{children}</tr>;
  }

  static deserialize({
    el,
    next,
  }: DeserializeArguments): TableRowElement | undefined {
    if (!isHTMLElementNode(el) || el.tagName.toLowerCase() !== 'tr') return;

    return {
      type: 'table-row',
      children: next(el.children, {}),
    };
  }
}

export default SerializerTableRow;
